const USER_PAYLOAD_CAMEL_TO_PASCAL = {
  passwordDefinition: 'PasswordDefinition',
  phoneNumber: 'PhoneNumber',
  name: 'Name',
  email: 'Email',
  clients: 'Clients',
  units: 'Units',
  active: 'Active',
  profile: 'Profile',
  document: 'Document',
  birthDate: 'BirthDate',
  claims: 'Claims'
}

const CLAIMS_CAMEL_TO_PASCAL = {
  dmpeople_grupo_id: 'dmpeople_grupo_id'
}

function toIdpUserPayloadCasing(payload, dmcenterOidd) {
  if (payload == null) return payload
  if (dmcenterOidd === true) return payload

  const result = {}
  for (const key of Object.keys(payload)) {
    const pascalKey = USER_PAYLOAD_CAMEL_TO_PASCAL[key] || key
    const value = payload[key]

    if (key === 'claims' && value && typeof value === 'object' && !Array.isArray(value)) {
      const claimsResult = {}
      for (const claimKey of Object.keys(value)) {
        const pascalClaimKey = CLAIMS_CAMEL_TO_PASCAL[claimKey] || claimKey
        claimsResult[pascalClaimKey] = value[claimKey]
      }
      result[pascalKey] = claimsResult
    } else {
      result[pascalKey] = value
    }
  }
  return result
}

function readRecoveryPasswordUrl(data, dmcenterOidd) {
  if (data == null) return data
  return dmcenterOidd === true ? data.passwordDefinitionUrl : data.PasswordDefinitionUrl
}

export { toIdpUserPayloadCasing, readRecoveryPasswordUrl }
